<template>
  <div class="farlig-kryds-container">
    <span class="farlig-kryds-icon"><Advarsel :width="26" /></span>
    <span class="farlig-kryds-text">Vær særlig opmærksom i kryds mellem {{ uheldssted }}</span>
  </div>
</template>

<script>
import Advarsel from '@/components/Icons/Advarsel.vue';

export default {
  name: 'farlig-kryds',
  components: {
    Advarsel,
  },
  props: { farligKryds: Object },
  computed: {
    billeder: function() {
      return this.farligKryds.properties.billeder;
    },
    draebte: function() {
      return this.farligKryds.properties.draebte_tilskadekomne;
    },
    tiltag: function() {
      return this.farligKryds.properties.tiltag;
    },
    uheldssted: function() {
      return this.farligKryds.properties.uheldssted.replace('/', ' og ');
    },
    ulykker: function() {
      return this.farligKryds.properties.ulykker;
    },
  },
};
</script>

<style lang="scss" scoped>
.farlig-kryds-container {
  // display: flex;
  // align-items: center;
  padding: 8px;
  margin-left: 8px;
  position: relative;
}

.farlig-kryds-icon {
  position: absolute;
  top: 25%;
  left: -41px;
}
</style>
